

import React, { useEffect, useState } from 'react';
import { Pencil, Trash, Plus, Search, Mail, Phone, FileText, Eye } from 'lucide-react';
import { useAdmin } from '../AdminLayout/AdminProvider';
import axios from 'axios';

import { State, City } from "country-state-city";

const API_BASE = "https://api.propertygalleria.in/master/api";

const API_BASEE = "http://localhost:4001";


export const Investor = () => {
  const {investor, associates, projects, addAssociate, updateAssociate, deleteAssociate, fetchAssociates, projectHeads, fetchInvestor } = useAdmin();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingAssociate, setEditingAssociate] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [aadharVerified, setAadharVerified] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  console.log('this projectHeads', projectHeads)
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    projectId: '',
    aadharKyc: null,
    experience_years: '',
    designation: "",
  });


  const sendAadharOtp = async () => {
    if (formData.aadharKyc.length !== 12) {
      alert("Enter valid 12-digit Aadhaar number");
      return;
    }

    try {
      setLoadingOtp(true);
      await axios.post(`${API_BASE}/api/send-aadhar-otp`, {
        Aadhar_No: formData.aadharKyc,
      });
      setOtpSent(true);
      alert("OTP sent successfully");
    } catch (err) {
      alert("Failed to send OTP");
    } finally {
      setLoadingOtp(false);
    }
  };



  const verifyAadharOtp = async () => {
    if (!otp) {
      alert("Enter OTP");
      return;
    }

    try {
      await axios.post(`${API_BASE}/api/verify-aadhar-otp`, {
        otp,
        Aadhar_No: formData.aadharKyc,
      });

      setAadharVerified(true);
      alert("Aadhaar verified successfully");
    } catch (err) {
      alert("OTP verification failed");
    }
  };
  // const getProjectName = (projectId) => {
  //   console.log('this is projectIdoo',projectId)
  //   const id = Number(projectId); // 👈 CRITICAL
  //   const project = projects.find(p => p.id === id);
  //   return project ? project.title : "";
  // };

  const getProjectName = (projectId) => {
    const id = Number(projectId);
    const project = projects.find(p => p.id === id);
    return project ? project.title : "Not Assign ";
  };



  const handleSubmit = (e) => {
    e.preventDefault();

    //     if (!aadharVerified) {
    //   alert("Please verify Aadhaar before submitting");
    //   return;
    // }


    if (!formData.name || !formData.email || !formData.mobile) {
      alert('Please fill all required fields');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Please enter a valid email address');
      return;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(formData.mobile)) {
      alert('Please enter a valid 10-digit mobile number');
      return;
    }

    const selectedProject = projects.find(
      (p) => p.id === Number(formData.projectId)
    );

    const associateData = {
      role: "agent",
      full_name: formData.name,
      email: formData.email,
      mobile_number: formData.mobile,

      aadhaar_number: formData.aadharKyc || undefined,

      aadhaar_verified: "1",
      experience_years: formData.experience_years,         // or from input if you add it
      // project_name: formData.projectId,
      project_name: Number(formData.projectId), // ✅ ID
      reports_to_head_id: formData.reports_to_head_id,
      state: formData.state,
      city: formData.city,
      profession: formData.profession,
      designation: formData.designation,
      //project_name: selectedProject?.project_name || "",
      is_admin_approve: 1          // 👈 always 1
    };

    console.log('this is associateData', associateData)
    if (editingAssociate) {

      //updateAssociate(editingAssociate.associate_code, associateData);
      updateAssociate(editingAssociate.id, associateData);

      alert('Associate updated successfully');
    } else {
      addAssociate(associateData);
      alert('Associate created successfully');
    }

    resetForm();
  };

  const resetForm1 = () => {
    setFormData({
      name: '',
      email: '',
      mobile: '',
      projectId: '',
      aadharKyc: null,
    });
    setEditingAssociate(null);
    setIsFormOpen(false);
  };

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      mobile: '',
      projectId: '',
      aadharKyc: '',
      experience_years: '',
      reports_to_head_id: '',
      state: '',
      city: ''
    });
    setEditingAssociate(null);
    setIsFormOpen(false);
    setOtp('');
    setOtpSent(false);
    setAadharVerified(false);
  };


  // const handleEdit_old= (associate) => {
  //   const project = projects.find(
  //     (p) => p.project_name === associate.project_name
  //   );
  //   setEditingAssociate(associate);
  //   setFormData({
  //     name: associate.name,
  //     email: associate.email,
  //     mobile: associate.mobile,
  //     projectId: project ? project.id : "",
  //     aadharKyc: associate.aadhar_no,
  //   });
  //   setIsFormOpen(true);
  // };


  const handleEdit1 = (associate) => {
    setEditingAssociate(associate);

    setFormData({
      name: associate.full_name,
      email: associate.email,
      mobile: associate.mobile_number,
      projectId: projects.find(p => p.title === associate.project_name)?.id || "",
      aadharKyc: associate.aadhaar_number,
      experience_years: associate.experience_years,
      reports_to_head_id: associate.reports_to_head_id
    });

    setIsFormOpen(true);
  };


  const handleEdit = (associate) => {
    // ✅ RESET FIRST (important)
    setFormData({
      name: '',
      email: '',
      mobile: '',
      projectId: '',
      aadharKyc: '',
      experience_years: '',
      reports_to_head_id: '',
      state: '',
      city: '',
    });

    // ✅ SET EDIT MODE
    setEditingAssociate(associate);

    // ✅ SET DATA FROM CLICKED ROW
    setFormData({
      name: associate.full_name || '',
      email: associate.email || '',
      mobile: associate.mobile_number || '',
      projectId: associate.project_name ? String(associate.project_name) : '',
      aadharKyc: associate.aadhaar_number || '',
      experience_years: associate.experience_years || '',
      reports_to_head_id: associate.reports_to_head_id || '',
      state: associate.state || '',
      city: associate.city || '',
    });

    setIsFormOpen(true);
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this associate?')) {
      deleteAssociate(id);
      alert('Associate deleted successfully');
    }
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      setFormData({ ...formData, aadharKyc: files[0] });
    }
  };
  console.log('this is associates', associates)
  const filteredAssociates = investor.filter(
    (associate) =>
      associate.full_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      associate.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      associate.mobile_number.includes(searchTerm)
  );

  const getProjectNamee = (projectId) => {
    const id = Number(projectId); // convert string to number
    const project = projects.find((p) => p.id === id);
    return project ? project.project_name : projectId;
  };

  // Inline Styles
  const styles = {
    container: { padding: '24px', fontFamily: 'Arial, sans-serif' },
    header: { marginBottom: '24px' },
    title: { fontSize: '24px', fontWeight: 'bold', color: '#0B1C3D', marginBottom: '4px' },
    subtitle: { color: '#6B7280' },
    actionsBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', gap: '16px' },
    searchWrapper: { position: 'relative', flex: 1, maxWidth: '400px' },
    searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' },
    searchInput: { width: '100%', padding: '8px 16px 8px 36px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
    addButton: { display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
    formContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '24px', marginBottom: '24px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
    formTitle: { fontSize: '20px', fontWeight: '600', marginBottom: '16px', color: '#0B1C3D' },
    inputGroup: { marginBottom: '16px', display: 'flex', flexDirection: 'column' },
    label: { fontSize: '14px', fontWeight: '500', marginBottom: '4px', color: '#374151', textAlign: 'left' },
    required: { color: '#EF4444' },
    input: { padding: '8px 12px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
    buttonPrimary: { backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginRight: '8px' },
    buttonSecondary: { backgroundColor: '#E5E7EB', color: '#374151', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
    tableContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', overflowX: 'auto', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { textAlign: 'left', padding: '12px', backgroundColor: '#8b306d', color: 'white', textAlign: 'center' },
    td: { padding: '12px', color: '#374151', textAlign: 'center' },
    badge: { display: 'inline-flex', alignItems: 'center', padding: '4px 8px', borderRadius: '999px', backgroundColor: '#42987e', color: '#fff', fontSize: '12px' },
    actionButton: { padding: '4px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
    stats: { marginTop: '16px', fontSize: '14px', color: '#6B7280', textAlign: 'right' },
  };


  const [checkedUsers, setCheckedUsers] = useState([]);

  const toggleCheckbox = (userId) => {
    setCheckedUsers((prev) => {
      if (prev.includes(userId)) {
        return prev.filter((id) => id !== userId);
      } else {
        return [...prev, userId];
      }
    });
  };

  const handleSubmitApprove = async () => {
    try {
      // Approve all selected users
      await Promise.all(
        checkedUsers.map((userId) =>
          axios.put(`https://api.propertygalleria.in/master/api/approve/${userId}`)
        )
      );

      alert("Selected users approved successfully!");


      setCheckedUsers([]);
      fetchInvestor();
      fetchAssociates();
      // Optional: refresh list here
    } catch (error) {
      console.error(error);
      alert("Approval failed. Please try again.");
    }
  };


  const [users, setUsers] = useState([]);

  useEffect(() => {


    fetch("https://api.propertygalleria.in/master/api/get/users")
      .then(res => res.json())
      .then(data => setUsers(data));
  }, []);



  const getProjectHeadName = (headUserId) => {
    if (!headUserId) return "Not Assign ";

    const head = projectHeads.find(
      (ph) => Number(ph.id) === Number(headUserId)
    );

    return head ? head.full_name : "Not Assign ";
  };


  const states = State.getStatesOfCountry("IN");


  const [agentDesc, setAgentDesc] = useState([]);



  const fetchPropertyOwners = async () => {
    try {
      const res = await axios.get(`https://api.propertygalleria.in/master/api/get/agentdesignation`);
      setAgentDesc(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch property owners");
    }
  };

  useEffect(() => {
    fetchPropertyOwners();
  }, []);


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const totalPages = Math.ceil(filteredAssociates.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedLeads = filteredAssociates.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  console.log('this is paginatedLeads', paginatedLeads)

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>Associate Master</h1>
        <p style={styles.subtitle}>Manage associates and their project allocations</p>
      </div>

      {/* Actions Bar */}
      <div style={styles.actionsBar}>
        <div style={styles.searchWrapper}>
          <Search size={20} style={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search associates..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
        </div>
        {/* <button style={styles.addButton} onClick={() => setIsFormOpen(true)}>
          <Plus size={20} /> Add Associate
        </button> */}
      </div>

      {/* Form */}
      {isFormOpen && (
        <div style={styles.formContainer}>
          <h2 style={styles.formTitle}>{editingAssociate ? 'Edit Associate' : 'Create New Associate'}</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '16px' }}>
              {editingAssociate && (
                <div>
                  <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Project Allocation *</label>
                  <select
                    value={formData.projectId}
                    onChange={(e) => setFormData({ ...formData, projectId: e.target.value })}
                    style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
                  //  required
                  >
                    <option value="">Select Property</option>
                    {projects.map((project) => (
                      <option key={project.id} value={project.id}>
                        {project.title} - {project.location}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {/* <div>
                <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Property Head Allocation *</label>
                <select
                  value={formData.reports_to_head_id}
                  onChange={(e) => setFormData({ ...formData, reports_to_head_id: e.target.value })}
                  style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
                  required
                >
                  <option value="">Select Property Head</option>
                  {/* {associates.map((agent) => (
                                        <option key={agent.id} value={agent.id}>
                                            {agent.full_name}
                                        </option>
                                    ))} *

                  {users
                    .filter(u => u.role === "projectHead")
                    .map(agent => (
                      <option key={agent.id} value={agent.id}>
                        {agent.full_name}
                      </option>
                    ))}
                </select>
              </div> */}


              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Name <span style={styles.required}>*</span>
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="e.g., Jane Smith"
                  style={styles.input}
                  required
                />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Email <span style={styles.required}>*</span>
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="jane@example.com"
                  style={styles.input}
                  required
                />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Mobile Number <span style={styles.required}>*</span>
                </label>
                <input
                  type="tel"
                  value={formData.mobile}
                  onChange={(e) => setFormData({ ...formData, mobile: e.target.value.replace(/\D/g, '').slice(0, 10) })}
                  placeholder="6309824545"
                  style={styles.input}
                  required
                />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Years of Experience <span style={styles.required}>*</span>
                </label>
                <input
                  type="number"
                  value={formData.experience_years}
                  onChange={(e) => setFormData({ ...formData, experience_years: e.target.value })}
                  placeholder="Enter you Experience"
                  style={styles.input}
                  required
                />
              </div>


              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Profession <span style={styles.required}>*</span>
                </label>
                <input
                  type="profession"
                  value={formData.profession}
                  onChange={(e) => setFormData({ ...formData, profession: e.target.value })}
                  placeholder="Enter your Profession"
                  style={styles.input}
                  required
                />
              </div>

              <div>
                <label style={styles.label}>Designations *</label>
                <select
                  value={formData.designation}
                  onChange={(e) =>
                    setFormData({ ...formData, designation: e.target.value })
                  }
                  style={styles.input}
                  required
                >
                  <option value="">Select Owner</option>
                  {agentDesc.map((owner) => (
                    <option key={owner.id} value={owner.designation}>
                      {owner.designation}
                    </option>
                  ))}
                </select>
              </div>



              <div style={styles.inputGroup}>
                <label style={styles.label}>State</label>
                <select
                  style={styles.input}
                  value={formData.state}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      state: e.target.value,
                      city: "" // reset city when state changes
                    })
                  }
                  required
                >
                  <option value="">Select State</option>
                  {states.map((state) => (
                    <option key={state.isoCode} value={state.isoCode}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>City</label>
                <select
                  style={styles.input}
                  value={formData.city}
                  onChange={(e) =>
                    setFormData({ ...formData, city: e.target.value })
                  }
                  required
                  disabled={!formData.state}
                >
                  <option value="">Select City</option>
                  {City.getCitiesOfState("IN", formData.state).map((city) => (
                    <option key={city.name} value={city.name}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  Aadhaar Number <span style={styles.required}>*</span>
                </label>
                <input
                  type="text"
                  value={formData.aadharKyc}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      aadharKyc: e.target.value.replace(/\D/g, "").slice(0, 12),
                    })
                  }
                  placeholder="Enter 12-digit Aadhaar"
                  style={styles.input}
                  maxLength={12}
                />
              </div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <button
                  type="button"
                  onClick={sendAadharOtp}
                  disabled={loadingOtp || otpSent}
                  style={styles.buttonSecondary}
                >
                  {loadingOtp ? "Sending..." : otpSent ? "OTP Sent" : "Send OTP"}
                </button>

                {aadharVerified && (
                  <span style={{ ...styles.badge, backgroundColor: "#16A34A" }}>
                    Verified
                  </span>
                )}
              </div>

              {otpSent && !aadharVerified && (
                <div style={{ marginTop: 8 }}>
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                    placeholder="Enter OTP"
                    style={styles.input}
                  />
                  <button
                    type="button"
                    onClick={verifyAadharOtp}
                    style={{ ...styles.buttonPrimary, marginTop: 8 }}
                  >
                    Verify OTP
                  </button>
                </div>
              )}

            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
              <button type="submit" style={styles.buttonPrimary}>
                {editingAssociate ? 'Update Associate' : 'Create Associate'}
              </button>
              <button type="button" onClick={resetForm} style={styles.buttonSecondary}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Associates Table */}
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              {/* <th style={styles.th}>Associate Code</th> */}
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Mobile</th>
              <th style={styles.th}>Project Assigned</th>
              {/* <th style={styles.th}>Aadhar KYC</th> */}
              {/* <th style={styles.th}>Project Head </th> */}
              {/* <th style={styles.th}>Actions</th> */}
              <th style={styles.th}>Approve </th>
            </tr>
          </thead>
          <tbody>
            {paginatedLeads.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ ...styles.td, textAlign: 'center', padding: '32px', color: '#9CA3AF' }}>
                  {searchTerm
                    ? 'No associates found matching your search'
                    : 'No associates created yet. Click "Add Associate" to get started.'}
                </td>
              </tr>
            ) : (
              paginatedLeads.map((associate, index) => (
                <tr
                 // key={associate.user_id}
                  key={`${associate.id}-${associate.reports_to_head_id}`}


                  style={{
                    backgroundColor: index % 2 === 0 ? 'white' : '#F9FAFB',
                    transition: 'background-color 0.2s',
                  }}
                >
                  {/* <td style={styles.td}>
                    {associate.custom_id}
                  </td> */}
                  <td style={styles.td}>{associate.full_name}</td>
                  <td style={styles.td}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <Mail size={16} color="#9CA3AF" />
                      {associate.email}
                    </div>
                  </td>
                  <td style={styles.td}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <Phone size={16} color="#9CA3AF" />
                      {associate.mobile_number}
                    </div>
                  </td>
                  <td style={styles.td}>
                    <span style={styles.badge}>{getProjectName(associate.project_name)}</span>
                  </td>
                  {/* <td style={styles.td}>
                    {associate.aadhaar_number ? associate.aadhaar_number : <span style={{ color: '#9CA3AF', fontSize: '12px' }}>N/A</span>}
                  </td> */}
                  {/* <td style={styles.td}>
                    <span style={styles.badge}>{associate.reports_to_head_id}</span>
                  </td> */}

                  {/* <td style={styles.td}>
                    <span style={styles.badge}>
                      {getProjectHeadName(associate.reports_to_head_id)}
                    </span>
                  </td> */}

                  {/* <td style={styles.td}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                      {/* <button
                        // onClick={() => openViewModal(associate)}
                        style={{ ...styles.actionButton, color: '#8b306d' }}
                        title="View"
                      >
                        <Eye size={18} />
                      </button> *
                      <button onClick={() => handleEdit(associate)} style={{ ...styles.actionButton, color: '#8b306d' }} title="Edit">
                        <Pencil size={18} />
                      </button>
                      <button onClick={() => handleDelete(associate.id)} style={{ ...styles.actionButton, color: '#42987e' }} title="Delete">
                        <Trash size={18} />
                      </button>
                    </div>
                  </td> */}
                  {/* <td style={styles.td}>{associate.is_admin_approve}</td> */}
                  <td style={styles.td}>
                    <input
                      type="checkbox"
                      checked={
                        associate.is_admin_approve === 1
                          ? true
                          : checkedUsers.includes(associate.id)
                      }
                      // disabled={associate.is_admin_approve === 1}
                      onChange={() => toggleCheckbox(associate.id)}
                    />
                  </td>

                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* ✅ Show Submit Button only if at least 1 checked */}
        {checkedUsers.length > 0 && (
          <div style={{ marginTop: "16px", textAlign: "right" }}>
            <button onClick={handleSubmitApprove} style={styles.submitButton}>
              Approve the User
            </button>
          </div>
        )}
      </div>

      {/* Stats */}
      <div style={styles.stats}>
        Total Associates: {filteredAssociates.length}
        {searchTerm && ` (filtered from ${associates.length})`}
      </div>



      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 16px",
          borderTop: "1px solid #E5E7EB",
          background: "#F9FAFB",
        }}
      >
        <div style={{ fontSize: 14, color: "#6B7280" }}>
          Showing {startIndex + 1}–
          {Math.min(startIndex + itemsPerPage, filteredAssociates.length)} of{" "}
          {filteredAssociates.length}
        </div>

        <div style={{ display: "flex", gap: "6px" }}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
            style={{
              padding: "6px 12px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              background: currentPage === 1 ? "#eee" : "#fff",
              cursor: "pointer",
            }}
          >
            Prev
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .slice(
              Math.max(0, currentPage - 3),
              Math.min(totalPages, currentPage + 2)
            )
            .map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                style={{
                  padding: "6px 12px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  background:
                    currentPage === page ? "#8b306d" : "#fff",
                  color: currentPage === page ? "#fff" : "#333",
                  cursor: "pointer",
                }}
              >
                {page}
              </button>
            ))}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
            style={{
              padding: "6px 12px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              background:
                currentPage === totalPages ? "#eee" : "#fff",
              cursor: "pointer",
            }}
          >
            Next
          </button>
        </div>
      </div>

    </div>
  );
};
